module MonitoringRules {
    "use strict";
    export function AddRuleEditorDirective(): ng.IDirective {
        return {
            restrict: "EA",
            bindToController: {
                onRuleAdded: "&",
                showEditor: "="
            },
            templateUrl: "AddNewMonitoringRuleTemplate",
            controller: "AddRuleEditorController",
            controllerAs: "editorCtrl"
        }
    }
    module.directive("frendsAddRuleEditor", AddRuleEditorDirective);

    export class AddRuleEditorController {
        public showEditor: boolean;
        public activeWeekDayViewModels: IActiveWeekDayViewModel[];
        public rule: MonitoringRuleViewModel = new MonitoringRuleViewModel();
        public hourArray: IHourEntry[]

        static $inject = ["$scope", "currentTimeZoneName"];
        constructor(private $scope: IValidationScope, private currentTimeZoneName: string) {
            this.initRule();
            this.hourArray = this.createHourArray();
        }

        initRule() {
            this.activeWeekDayViewModels = this.getActiveWeekdayViewModels(this.rule.activeWeekDays || []);
            // TODO: could / should these be set in the monitoringRule constructor?
            this.rule.timeZone = this.currentTimeZoneName;
            this.rule.aggregate = "Count";
            this.rule.operator = "GreaterThan";
        }

        saveNewRule($form: IRuleFormController) {
            this.validate($form);

            if ($form.$invalid) {
                // errors -> show by setting the magic constant in the scope
                this.$scope.showValidationErrors = true;
                return false;
            }

            console.log("Saving new rule ", this.rule);
            this.onRuleAdded({ newRule: this.rule });

            this.resetForm($form);
        }

        cancel($form: IRuleFormController) {
            this.resetForm($form);
        }

        resetForm($form: IRuleFormController) {
            this.rule = new MonitoringRuleViewModel();
            this.initRule();
            this.showEditor = false;
            this.$scope.showValidationErrors = false;
            $form.$setPristine();
            $form.$setUntouched();
        }

        onRuleAdded({newRule: MonitoringRuleViewModel}) {
            // will be initialized by angular, here only for making compiler happy
        }

        private validate($form: IRuleFormController) {
            let endTimeValid = _.isUndefined(this.rule.endHour) || this.rule.endHour > this.rule.startHour;
            $form.ruleEndTime.$setValidity("pattern", endTimeValid); // reuse the 'pattern' key for showing just 'value is invalid'
        }
        public updateActiveWeekdaysForRule() {
            this.rule.activeWeekDays = this.activeWeekDayViewModels.filter(m => !!m.selected).map(m => m.value);
        }

        public getActiveWeekdayViewModels(activeWeekDays: string[]): IActiveWeekDayViewModel[] {
            return MonitoringRuleViewModel.WEEK_DAYS.map(x => {
                return {
                    name: x.name,
                    value: x.value,
                    selected: activeWeekDays.indexOf(x.value) !== -1
                }
            });
        }

        public createHourArray(): IHourEntry[] {
            return _.range(0, 25, 1).map(i => {
                return {
                    value: i,
                    text: moment(i.toString(), "H").format("HH:mm")
                }
            });
        }
    }

    module.controller("AddRuleEditorController", AddRuleEditorController);

    interface OnRuleAddedCallback {
        (newRule: MonitoringRuleViewModel): void;
    }

    interface IValidationScope extends ng.IScope {
        showValidationErrors: boolean;
    }

    interface IRuleFormController extends ng.IFormController {
        ruleStartTime: ng.INgModelController;
        ruleEndTime: ng.INgModelController;
    }

    interface IHourEntry {
        value: number;
        text: string;
    }
}